<template>
  <li>{{ meal.recipe.name }}</li>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Meal",
  props: {
    meal: Object,
  },
});
</script>
